/**
 * Loads modules required for the main content matrix
 */

import { loadModule, loadModulesWhenInView } from '@helpers/loadModule';
import cookieConsent from '@modules/cookieConsent';

export default function init(): void {
  cookieConsent();

  // Load video early so autoplay heroes can attach players without waiting for in-view
  loadModule('.js-video-container', () => import('@modules/video'));

  // Load optional modules when in view
  loadModulesWhenInView([
    {
      selector: '.js-dropdown-trigger',
      importer: () => import('@modules/dropdown'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/formieCsrf'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/gtmFormSubmission'),
    },
    {
      selector: '.js-embla',
      importer: () => import('@modules/embla'),
    },
    {
      selector: '.js-accordion-item',
      importer: () => import('@modules/accordion'),
    },
  ]);
}
